import React from "react";
import { Calendar, Flame, Award } from "lucide-react";
import { weekDates } from "../lib/gameLogic";

export default function WeeklyCalendar({ state }) {
  const days = weekDates();
  const completedThisWeek = days.filter(
    (d) => state.completedDays[d.key],
  ).length;

  return (
    <div
      className="border border-white/10 bg-[#0A0D14] p-5 md:p-6"
      data-testid="weekly-calendar"
    >
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-blue-400/80 flex items-center gap-1.5">
            <Calendar className="h-3 w-3" /> Weekly Log
          </div>
          <h3 className="font-display uppercase font-bold text-xl mt-1">
            Last 7 Days
          </h3>
        </div>
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500">
            Cleared
          </div>
          <div className="font-mono text-2xl font-bold text-purple-300">
            {completedThisWeek}/7
          </div>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-7 gap-1.5">
        {days.map((d) => {
          const done = !!state.completedDays[d.key];
          return (
            <div
              key={d.key}
              className={`relative aspect-square flex flex-col items-center justify-center border ${
                d.isToday
                  ? "border-purple-400"
                  : done
                    ? "border-blue-500/40"
                    : "border-white/10"
              } ${done ? "bg-gradient-to-br from-blue-600/20 to-purple-600/20" : "bg-black/30"}`}
              data-testid={`calendar-day-${d.key}`}
            >
              <div className="text-[10px] uppercase tracking-widest text-slate-500">
                {d.label}
              </div>
              <div
                className={`font-mono text-lg font-bold ${
                  done ? "text-white" : "text-slate-600"
                }`}
              >
                {d.dayNum}
              </div>
              {done && (
                <Flame className="absolute top-1 right-1 h-3 w-3 text-orange-400" />
              )}
              {d.isToday && (
                <div className="absolute -bottom-1 left-0 right-0 h-px bg-purple-400" />
              )}
            </div>
          );
        })}
      </div>

      <div className="mt-5 grid grid-cols-2 gap-3">
        <MiniStat
          icon={<Flame className="h-4 w-4 text-orange-400" />}
          label="Current Streak"
          value={`${state.streak} days`}
        />
        <MiniStat
          icon={<Award className="h-4 w-4 text-purple-300" />}
          label="Total Workouts"
          value={state.totalWorkouts}
        />
      </div>
    </div>
  );
}

const MiniStat = ({ icon, label, value }) => (
  <div className="border border-white/10 bg-black/30 p-3">
    <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-slate-400">
      {icon}
      {label}
    </div>
    <div className="mt-1 font-mono text-xl font-bold text-white">{value}</div>
  </div>
);
